export default () => {
  return (
    <svg
      t="1677469260707"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="5191"
    >
      <path
        d="M554.666667 145.066667l85.333333 183.466666c8.533333 12.8 21.333333 21.333333 34.133333 25.6l196.266667 29.866667c38.4 4.266667 51.2 51.2 25.6 76.8l-145.066667 149.333333c-8.533333 8.533333-12.8 25.6-12.8 38.4l34.133334 209.066667c4.266667 38.4-34.133333 64-68.266667 46.933333l-170.666667-93.866666c-12.8-8.533333-29.866667-8.533333-42.666666 0l-170.666667 93.866666c-34.133333 17.066667-72.533333-8.533333-68.266667-46.933333l34.133334-209.066667c4.266667-12.8-4.266667-29.866667-12.8-38.4L128 460.8c-25.6-25.6-12.8-72.533333 25.6-76.8l196.266667-29.866667c17.066667 0 29.866667-12.8 34.133333-25.6l85.333333-183.466666c17.066667-34.133333 68.266667-34.133333 85.333334 0z"
        p-id="5192"
      ></path>
    </svg>
  );
};
